import { Component } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { finalize } from 'rxjs';
import { MdbModalRef } from 'mdb-angular-ui-kit/modal';

import { VehicleModel } from '../../../../models/resources/vehicle.model';
import { VehicleFormComponent } from '../../../forms/vehicle-form/vehicle-form.component';
import { ModalComponent } from '../../../utils/modal/modal.component';

import { VehicleService } from '../../../../services/resources/vehicle.service';
import { HttpErrorsService } from '../../../../services/utils/http-errors.service';


@Component({
  selector: 'app-new-vehicle-modal',
  imports: [
    VehicleFormComponent,
    ModalComponent,
],
  templateUrl: './new-vehicle-modal.component.html',
  styleUrl: './new-vehicle-modal.component.scss',
})
export class NewVehicleModalComponent {
  loading: boolean = false;
  formGroup: FormGroup | undefined;

  constructor(
    private modalRef: MdbModalRef<NewVehicleModalComponent>,
    private httpErrorService: HttpErrorsService,
    private vehicleService: VehicleService
  ) {}

  submit() {
    this.formGroup!.markAllAsTouched();

    if (this.formGroup!.invalid)
      return;

    this.loading = true;

    let resource = this.formGroup?.value;

    this.vehicleService
    .create(resource)
    .pipe(finalize(() => (this.loading = false)))
    .subscribe({
      next: (vehicle: VehicleModel) => {
        this.modalRef.close(vehicle);
      },
      error: (e) => {
        this.httpErrorService.handleError(e);
      },
    });
  }

  getValueOf(controlName: string) {
    return this.formGroup?.get(controlName)?.value;
  }
}

